module.exports = __webpack_public_path__ + "dom_ios_qr.21d5fcf.png";